import urlJoin from 'url-join'

export interface IUrlsConfig {
    passportUrlBase: string
    accountUrlBase: string
    accountServiceUrlBase: string
}

export function makeUrls(config: IUrlsConfig) {
    const {
        passportUrlBase,
        accountUrlBase,
        accountServiceUrlBase
    } = config
    const AdminJ = (p: string) => urlJoin(accountServiceUrlBase, '/user-service/admin' + p) as string
    const AccountJ = (p: string) => urlJoin(accountUrlBase, p) as string
    return {
        case_time: {
            getCheckCaseUserAuthorize: AdminJ('/business/cases/authorize/user'), // 老的，可能不需要了
            getCheckCaseUserAuthorizeV2: AdminJ('/business/cases/authorize/case-popup'),
            getAllCompanyCaseBase: AdminJ('/business/cases/company/base'),
            getCurrentUserCaseView: AdminJ('/business/cases/user/view'),
            getUserCaseView: AdminJ('/business/cases/user_id={user_id}/view'),
            putCaseOperation: AdminJ('/business/cases/user/operation'),
            watchDog: AdminJ('/business/cases/watchdog')
        },
        passport: {
            caseTimeDetail: AccountJ('/user-settings/#/user/case_time')
        }
    }
}

type IUrls = ReturnType<typeof makeUrls>
export type ICaseTimeUrls = IUrls['case_time']
export type IPassportUrls = IUrls['passport']
